"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TestimonialCardTrustpilotStar = _interopRequireDefault(require("./TestimonialCardTrustpilotStar"));
var _uxUtils = require("@site/ux-utils");
const TestimonialCard = ({
  text,
  authorName,
  authorTitle
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "testimonial-card",
    "data-testid": "testimonial-card",
    className: "testimonial-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rating"
  }, /*#__PURE__*/_react.default.createElement(_TestimonialCardTrustpilotStar.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "testimonial-text"
  }, (0, _uxUtils.useFormatMessage)(text)), /*#__PURE__*/_react.default.createElement("div", {
    className: "author"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "author-name"
  }, (0, _uxUtils.useFormatMessage)(authorName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "author-title"
  }, (0, _uxUtils.useFormatMessage)(authorTitle))));
};
TestimonialCard.propTypes = {
  text: _propTypes.default.string,
  authorName: _propTypes.default.string,
  authorTitle: _propTypes.default.string
};
var _default = exports.default = TestimonialCard;